import React from "react";
import {
    Card,
    Form,
    Row,
    Col,
    Input,
    Button,
    message,
    Spin,
    Popconfirm,
} from "antd";

import { moaApi } from "../../../../../../api";

const {
    reqContactsAdd,
    reqContactsDel,
    reqContactsEdit,
    reqContactsDetail
} = moaApi;

class ContactsAdd extends React.Component {
    state = {
        loading: true,
        detail: {},
    };
    cid = this.props.match.params.cid;
    id = this.props.match.params.id;

    validate = async (values) => {
        let response;
        if (!this.id) {
            for (let i in values) {
                if (!values[i]) {
                    delete values[i];
                }
            }
        }
        if (this.id) {
            values.id = this.id;
            response = await reqContactsEdit(values);
            if (response && response.data) {
                message.success('修改成功');
                this.props.history.goBack();
            }
        } else {
            values.fund = [this.cid];
            response = await reqContactsAdd(values);
            if (response && response.data) {
                message.success('添加成功');
            }
        }
    };

    delContacts = async () => {
        const response = await reqContactsDel({
            id: this.id
        });
        if (response && response.data) {
            message.success('删除成功');
            this.props.history.replace(`/moa/capital/detail/${this.cid}`);
        }
    };

    getContactsDetail = async (params = {}) => {
        const response = await reqContactsDetail(params);
        if (response && response.data) {
            this.cid = response.data.fund[0].id;
            this.setState({
                detail: response.data,
                loading: false
            });
        }
    };

    componentDidMount() {
        if (this.id) {
            // 获取详情
            this.getContactsDetail({
                id: this.id
            });
        }
    }

    render() {
        const { detail } = this.state;

        return this.id && this.state.loading ? (
            <div className="loading-container">
                <Spin size="large" />
            </div>
        ) : (
            <Form onFinish={this.validate}>
                <Button
                    type="link"
                    icon="left"
                    onClick={() => {
                        this.props.history.goBack();
                    }}
                >返回</Button>

                <Card
                    title={
                        this.id ? "修改申报联络人信息" : "添加申报联络人"
                    }
                    style={{
                        marginBottom: 24,
                    }}
                    bordered={false}
                    extra={
                        this.id ? (
                            <Popconfirm
                                title="确定删除该申报联络人信息吗?"
                                onConfirm={this.delContacts}
                                okText="确定"
                                cancelText="取消"
                            >
                                <Button>删除</Button>
                            </Popconfirm>
                        ) : null
                    }
                >

                    <Card
                        title="申报联络人基本信息"
                        bordered={false}
                        type="inner"
                    >
                        <Form>
                            <Row gutter={{ sm: 0, md: 16, lg: 24 }}>
                                <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                                    <Form.Item
                                        label="姓名"
                                        name="name"
                                        initialValue={detail.name || ''}
                                        rules={[
                                            {
                                                required: true,
                                                message: '请输入申报联络人姓名',
                                            },
                                        ]}
                                    >
                                        <Input placeholder="请输入申报联络人姓名" />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                                    <Form.Item
                                        label="职务"
                                        name="post"
                                        initialValue={detail.post || ''}
                                        rules={[
                                            {
                                                required: true,
                                                message: '请输入申报联络人职务',
                                            },
                                        ]}
                                    >
                                        <Input placeholder="请输入申报联络人职务" />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                                    <Form.Item
                                        label="手机号"
                                        name="mobile"
                                        initialValue={detail.mobile || ''}
                                    >
                                        <Input placeholder="请输入申报联络人手机号" />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                                    <Form.Item
                                        label="微信号"
                                        name="wechat"
                                        initialValue={detail.wechat || ''}
                                    >
                                        <Input placeholder="请输入申报联络人微信号" />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                                    <Form.Item
                                        label="邮箱"
                                        name="email"
                                        initialValue={detail.email || ''}
                                    >
                                        <Input placeholder="请输入申报联络人邮箱" />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                                    <Form.Item
                                        label="办公座机"
                                        name="telephone"
                                        initialValue={detail.telephone || ''}
                                    >
                                        <Input placeholder="请输入申报联络人办公座机" />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                                    <Form.Item
                                        label="地址"
                                        name="place"
                                        initialValue={detail.place || ''}
                                    >
                                        <Input placeholder="请输入申报联络人所在地址" />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                    </Card>
                </Card>

                <div className="submit-footer">
                    <Button type="primary" htmlType="submit">
                        {
                            this.id ? '保存' : '提交'
                        }
                    </Button>
                </div>
            </Form>
        );
    }
}

export default ContactsAdd;